import { ReactNode } from "react";
import { Provider } from "../ui/provider";
import { Field as CField, FieldRootProps } from "@chakra-ui/react";

type Props = {
  label?: string;
  errorText?: string;
  helperText?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
};

export default function Field({
  label,
  errorText: errorMessage,
  helperText,
  htmlFor,
  children,
  ...rest
}: Props & Omit<FieldRootProps, "children">) {
  return (
    <CField.Root invalid={!!errorMessage} {...rest}>
      {label && (
        <CField.Label htmlFor={htmlFor} fontWeight={"normal"} color="fg.muted">
          {label}
        </CField.Label>
      )}
      {children}
      {errorMessage && <CField.ErrorText>{errorMessage}</CField.ErrorText>}
      {helperText && (
        <CField.HelperText w="full">{helperText}</CField.HelperText>
      )}
      {/* {label && (
          <label
            htmlFor={htmlFor}
            className={`text-[#333333] text-sm ${
              htmlFor ? "cursor-pointer" : ""
            }`}
          >
            {label}
          </label>
        )} */}
      {/* {children}
        {errorMessage && (
          <div className="text-red-700 text-sm">{errorMessage}</div>
        )}
        {helperText && (
          <p className="text-sm text-light text-muted-foreground italic">
            {helperText}
          </p>
        )} */}
    </CField.Root>
  );
}
